<template>
  <van-pull-refresh
    v-model="isLoading"
    @refresh="onRefresh"
    :pulling-text="$t('tips.pullrefresh')"
    :loosing-text="$t('tips.loosingrefresh')"
    :loading-text="$t('tips.loading')"
  >
    <van-search v-model="searchcontent" :placeholder="$t('member.search')" />
    <van-loading v-if="loading && !data.length" class="page-loading" />
    <van-list
      class="indexuserBox"
      v-model:loading="loading"
      v-model:error="loadFailed"
      :error-text="$t('tips.loadfail')"
      :finished="finished"
      :finished-text="$t('tips.nomore')"
      @load="onLoad"
      :immediate-check="false"
    >
      <User
        v-for="item in data"
        :key="item.id"
        :item="item"
        @follow="item.is_like = item.is_like == 0 ? 1 : 0"
      />
    </van-list>
  </van-pull-refresh>
</template>

<script>
import User from "./User.vue";
export default {
  data() {
    return {
      isLoading: false,
      searchcontent: "",
      setTimeout: null,
      data: [],
      loading: true,
      requestPending: false,
      loadFailed: false,
      failedPage: 0,
      requestId: 0,
      finished: false,
      page: 1,
      last_page: 0,
    };
  },
  watch: {
    searchcontent() {
      if (this.util.checkPermision("Search_users")) {
        clearTimeout(this.setTimeout);
        this.setTimeout = setTimeout(this.search, 500);
      }
    },
  },
  components: {
    User,
  },
  methods: {
    onRefresh() {
      return this.search();
    },
    follow() {
      ElMessage.success(this.$t("tips.followsuccess"));
    },
    search() {
      clearTimeout(this.setTimeout);
      return this.getUserList(1);
    },
    onLoad() {
      if (this.requestPending) return;
      if (!this.failedPage && this.finished) {
        this.loading = false;
        return;
      }
      const page = this.failedPage || (this.data.length ? this.page + 1 : 1);
      return this.getUserList(page);
    },
    async getUserList(page = 1) {
      const requestId = ++this.requestId;
      this.requestPending = this.loading = true;
      this.loadFailed = false;
      if (page === 1) this.finished = false;
      try {
        const response = await this.axios.post_form("/member/index/userlist", {
          page,
          username: this.searchcontent,
        });
        if (requestId !== this.requestId) return;
        const res = response.data;
        const empty = res.status == 0 && res.msg === "暂无异性用户";
        if (res.status != 200 && !empty) throw new Error("User list rejected");
        const items = empty ? [] : res.data.data;
        this.data = page === 1 ? items : this.data.concat(items);
        this.page = page;
        this.last_page = empty ? page : Number(res.data.last_page);
        this.finished = page >= this.last_page;
        this.failedPage = 0;
      } catch (error) {
        if (requestId === this.requestId) {
          this.loadFailed = true;
          this.failedPage = page;
        }
      } finally {
        if (requestId === this.requestId) {
          this.requestPending = this.loading = this.isLoading = false;
        }
      }
    },
  },
  created() {
    this.getUserList();
  },
  beforeUnmount() {
    clearTimeout(this.setTimeout);
    this.requestId++;
  },
};
</script>

<style lang="scss" scoped>
.page-loading {
  padding: 20px;
  text-align: center;
}

.indexuserBox {
  padding: 20px 0px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 100px;
  min-height: 501px;
}
</style>

<style lang="scss">
.van-list__finished-text {
  text-align: center;
  width: 100%;
}
</style>
